<template>
  <div>

    <c-tabs-navigation
      :links="[{
        name: 'Dashboard',
        to: { name: 'dashboard' }
      }, {
        name: 'Konto',
        to: { name: 'dashboard-account' }
      }, {
        name: 'Persönliche Daten',
        to: { name: 'dashboard-personal-data' },
        show: $is(['applicant'])
      }, {
        name: 'Bankverbindung',
        to: { name: 'dashboard-bank-account' },
        show: $is(['applicant'])
      }]"
      aria-label="Dashboard-Navigation"
    />

    <router-view />

  </div>
</template>

<script>
import CTabsNavigation from '@/components/CTabsNavigation'

export default {
  name: 'VDashboard',

  components: {
    CTabsNavigation
  }
}
</script>
